import { Avatar, Box, Stack, Typography } from '@mui/material';

export const getArticleText = (article) => article?.excerpt || article?.content || '';

export const getCollectionPath = (brandId, slug) => `/knowledge-base/${brandId}/collection/${slug || 'general'}`;

export const getArticlePath = (brandId, article) => {
  if (article?.collection_slug) {
    return `/knowledge-base/${brandId}/collection/${article.collection_slug}/${article.slug}`;
  }
  return `/knowledge-base/${brandId}/${article?.slug || ''}`;
};

export const getCollectionArticlePath = (brandId, collectionSlug, articleSlug) => {
  if (collectionSlug) {
    return `/knowledge-base/${brandId}/collection/${collectionSlug}/${articleSlug}`;
  }
  return `/knowledge-base/${brandId}/${articleSlug}`;
};

export const sanitizeKBHtml = (html = '') =>
  String(html)
    .replace(/<\s*(script|style|iframe|object|embed)[^>]*>.*?<\s*\/\s*\1\s*>/gis, '')
    .replace(/<\s*\/?\s*(script|style|iframe|object|embed)[^>]*>/gis, '')
    .replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/href\s*=\s*("|')\s*javascript:[^"']*\1/gi, 'href="#"');

export const htmlToPreviewText = (html = '') =>
  String(html)
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

export const formatRelativeTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const diffSeconds = Math.round((date.getTime() - Date.now()) / 1000);
  const absSeconds = Math.abs(diffSeconds);
  if (absSeconds < 45) return 'a few seconds ago';

  const units = [
    { unit: 'year', seconds: 31536000 },
    { unit: 'month', seconds: 2592000 },
    { unit: 'week', seconds: 604800 },
    { unit: 'day', seconds: 86400 },
    { unit: 'hour', seconds: 3600 },
    { unit: 'minute', seconds: 60 },
  ];
  const match = units.find((item) => absSeconds >= item.seconds);
  if (!match) return 'a few seconds ago';

  return new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' }).format(
    Math.round(diffSeconds / match.seconds),
    match.unit
  );
};

export function ArticleAuthorMeta({ article, compact = false }) {
  if (!article?.author_name && !article?.updated_at) return null;

  return (
    <Stack direction="row" spacing={1.25} alignItems="center" sx={{ mt: compact ? 0.5 : 1 }}>
      <Avatar
        sx={{
          width: compact ? 24 : 32,
          height: compact ? 24 : 32,
          bgcolor: 'secondary.main',
          color: 'secondary.contrastText',
          fontSize: compact ? 12 : 14,
        }}
      >
        {(article?.author_name || 'B').slice(0, 1).toUpperCase()}
      </Avatar>
      <Box>
        <Typography variant={compact ? 'caption' : 'body2'} sx={{ color: 'primary.main', fontWeight: 600, lineHeight: 1.2 }}>
          {article?.author_name || 'Brand2Chat Team'}
        </Typography>
        {article?.updated_at && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', lineHeight: 1.2 }}>
            Last Update {formatRelativeTime(article.updated_at)}
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
